import React, { Fragment } from 'react'
import { Carousel, } from 'antd'
import { ArrowRightOutlined } from '@ant-design/icons';
import './style.css'
export default function AppScene(props) {
    const { data } = props;
    return (
        <div className='AppScene'>
            {/* <img className='AppScene_Background' src='images/HomePage/AppScene/img1.png' /> */}
            <div className='AppSceneMain'>
                <div className='AppScene_Left'>
                    <div className='AppScene_LeftTitle'>应用场景</div>
                    <div className='AppScene_LeftTitleBottom' />
                    <div className='AppScene_LeftIntroduce'>
                        重大自然灾害应急监测与评估；
                        地球大数据减灾信息应用平台；
                        星机地协同地震灾情综合研判与指挥调度平台
                    </div>
                </div>
                <div className='AppScene_Right'>
                    {data.map((item, index) => {
                        return (
                            <div className='AppScene_Img' style={{ gridArea: 'img' + returnGridArea(index + 1) }}>
                                <img className='AppScene_ImgSrc' src={item.img} />
                                <div className='AppScene_ImgTitle' title={item.title}>{item.title}</div>
                            </div>
                        )
                    })}
                </div>
            </div>
        </div>
    )
}

function returnGridArea(num) {
    return num >= 10 ? num + '' : '0' + num;
}